import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer, Zoom } from 'react-toastify';
import { Provider } from 'react-redux';
import { App } from './App';
import { reportWebVitals } from './reportWebVitals';
import { store } from './redux/internal';
import { AuthVerify } from './components/authentication/AuthVerify';
import './index.scss';
import './assets/toastify.scss';
import { toastAutoClose } from './constants/application';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
      <ToastContainer
        autoClose={toastAutoClose}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        hideProgressBar
        transition={Zoom}
        className='error-message'
      />
      <AuthVerify />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
